@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;

.errorWrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: v.$z-index-route-map-error;
  opacity: 0;
  animation-delay: 0.4s;
  animation-duration: 0.4s;
  animation-name: appear;
  animation-fill-mode: forwards;
  font-family: v.$primary-font;

  @include c.containerMedia(v.$js-defined-tablet-breakpoint, "min") {
    width: calc(100% - v.$panel-wrapper-width);
  }


  .errorContent {
    padding: 2.4rem;
    background: v.$palette-white;
    box-shadow: 0 0.4rem 1.5rem v.$shadow-color-2;
    border-radius: 1rem;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.6rem;

      i {
        max-height: 2.4rem;
        font-size: 2.4rem;

        &:before {
          background: v.$gradient-warning;
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          display: initial;
        }
      }
    }

    p {
      @include t.text(16px, 20px, 600);
      text-align: center;
      color: v.$palette-gray-900;
    }
  }
}

@keyframes appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
